import React, { useState, Context, ReactElement, Component } from "react";
import WebWorker from "../worker/webworker";

const WasmContext: Context<[WebWorker, React.Dispatch<React.SetStateAction<WebWorker>>]> = React.createContext<[WebWorker, React.Dispatch<React.SetStateAction<WebWorker>>]>([null as unknown as WebWorker, (_value: any) => { }]);

const WasmProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [wasm, set_wasm] = useState(null as unknown as WebWorker);
    return (
        <WasmContext.Provider value={[wasm, set_wasm]}>
            {props.children}
        </WasmContext.Provider>
    )
}

export { WasmContext, WasmProvider };